import { styled } from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const ImageGalleryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    justify-content: center;
    text-align: center;
    gap: 1rem;
    padding: 1rem 1rem;
    flex-shrink: 0;
    width: 100%;
    overflow: none;
`;
export const SortFilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.25rem;
`;

export const LoaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    flex-shrink: 0;
    width: 100%;
    flex: 1 0 auto;
`;

export const FormControl = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 1.25rem;
`;

export const MenuItem = styled.option`
    font-size: 1rem;
    padding: 0.625rem;
`;

export const SearchInput = styled.input`
    padding: 0.625rem;
    font-size: 1rem;
    border: 0.0625rem solid ${colourScheme.white};
    border-radius: 0.25rem;
    flex: 1;
`;

export const ImageWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1rem;
    & > a {
        text-align: center;
    }
`;

export const ButtonContainer = styled.div`
    position: sticky;
    top: 0;
    z-index: 10; // Ensure it stays above other elements
    display: grid;
    gap: 0.5rem;
    background-color: ${colourScheme.primaryDark};
    border-radius: 0.5rem;
    border: 0.0625rem solid ${colourScheme.primaryLight};
    padding: 0.5rem;
    grid-template-columns: repeat(2, 1fr);

    & > button {
        font-size: 0.6rem;
    }

    ${device.lg} {
        & > button {
            font-size: 0.75rem;
        }
        display: flex;
        flex-direction: row;
        padding: 1rem;
    }
`;

export const SingleButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    background-color: ${colourScheme.primaryDark};
    border-radius: 0.5rem;
    border: 0.0625rem solid ${colourScheme.primaryLight};
    padding: 1rem;

    ${device.lg} {
        flex-direction: row;
        padding: 1.5rem;
    }
`;
